import React from "react";
import ResourceListPage from "commons/components/ResourceListPage";

const columns = [
  {
    name: "name",
    type: "text",
    sortable: true,
    searchable: true,
    searchKey: "service_locations.name",
  },
];

export default function List() {
  return (
    <ResourceListPage
      url="service-locations"
      title="ships"
      columns={columns}
      baseQuery={{
        type: "SHIP",
      }}
    />
  );
}
